// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import VeeValidate from 'vee-validate'
import 'bulma/css/bulma.css'
import 'font-awesome/css/font-awesome.min.css'
import Session from '@/library/Session.js'
import Custom from '@/library/Custom.js'
import Fly from '@/library/Fly.js'
import CoreConfig from '@/library/Configuration.js'

import geb from 'vue-geb'

import Tablebuttondropdown from '@/components/tablebuttondropdown'
import Breadcrumbs from '@/components/breadcrumbs'
import Preloader from '@/components/preloader'

import ImageUploader from 'vue-image-upload-resize'

Vue.use(VeeValidate)

Vue.use(Session)
Vue.use(Custom)
Vue.use(Fly)
Vue.use(CoreConfig)

Vue.use(geb)

Vue.component('table-button-dropdown', Tablebuttondropdown)
Vue.component('breadcrumbs', Breadcrumbs)
Vue.component('preloader', Preloader)

Vue.use(ImageUploader)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js